import { render } from "./RoomAdminPanel.vue?vue&type=template&id=33d89a41&scoped=true"
import script from "./RoomAdminPanel.vue?vue&type=script&lang=js"
export * from "./RoomAdminPanel.vue?vue&type=script&lang=js"

import "./RoomAdminPanel.vue?vue&type=style&index=0&id=33d89a41&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d89a41"]])

export default __exports__